import angular from "angular";

angular.module("tcMailgun", []);
